require([
    "common/accordion",
    "common/shuffle",
    "ProductTile/productTileComponent",
    "common/formUtils",
    "ProductsIndex/filterFacetsPosition",
    "common/urlUtils"
],
function (accordion, shuffle, productTileComponent, formUtils, filterFacetsPosition, urlUtils) {

    var lastSearch;
    var scrollDebounce = true;

    function initClickHandlers() {
        $(".facet-checkbox").off("click").on("click", executeSearch);
        $(".facet-clear").off("click").on("click", clearFacet);
        accordion.init(".products-filter");
        //$("#products-index-load-more-button").off("click").on("click", loadMore);
        $(".facet-breadcrumb .close-button").off("click").on("click", clearFacetCheckbox);
        productTileComponent.initClickHandlers();
    }

    function executeSearch(event, categoryFilterChanged, initialSearch) {

        $("#products-index-message").removeClass("error").empty();

        if (initialSearch) {
            showResults(initialProductsIndexData.Data);
            initialProductsIndexData = null; // just cleaning up, since we don't need this any more
            $(".products-index-item").removeClass("d-none");     // we don't need the "d-none" class any more because now the Shuffle has taken over displaying and hiding the product tiles
            return;   // for the initial display of products we don't need the AJAX part that follows
        }

        var postData = {
            categoryId: $("#products-index").data("categoryId"),
            alsoInCategoryId: currentCategoryFilter,
            generateListOfCategories: generateCategoryFilters,
            selectedFacetValues: [],
            openFacets: []
        };

        lastSearch = postData;

        currentDisplayCountLimit = pageSize;

        if (categoryFilterChanged) {
            // if category filter was changed then we don't want to keep selected facets
        }
        else {
            // go through all selected facets and send those to back end search engine
            postData.selectedFacetValues = $(".facet-checkbox:checked").map(function () {
                return {
                    facet: this.name,
                    value: this.value,
                    valueId: this.id,
                    facetDisplayName: this.title
                };
            }).get();

            postData.openFacets = $(".facet:has('.custom-accordion-content.open')").map(function () {
                return this.attributes["data-facet-name"].value;
            }).get();
        }
        formUtils.useToken(postData);

        spinner("show");
        $.ajax({
            type: "POST",
            url: "/customapi/Product/Search",
            dataType: "json",
            data: postData,
            success: function (data) {
                if (lastSearch !== postData) {
                    return;
                }

                if (data.status === "OK") {
                    showResults(data);
                } else {
                    // Something's not right.
                    // Display the error messages (if any) and stay on the page.
                    $("#products-index-message").addClass("error").html(data.message);
                }
            },
            error: function (jq, status, errorThrown) {
                if (lastSearch !== postData) {
                    return;
                }

                $("#products-index-message").addClass("error").html(status + ". " + errorThrown);
            },
            complete: function () {
                if (lastSearch !== postData) {
                    return;
                }

                spinner("hide");
                generateCategoryFilters = false;  // we only need this the first time we execute search
            }
        });

    }

    function showResults(data) {
        setScrollLoading();       
        $("#products-filter-facets").empty().html(data.facets);
        // put selected facets into query string
        putSelectedFacetsIntoQueryString();
        // Display the products.
        shuffle.changeContent(shuffleInstance, data.products, currentDisplayCountLimit);
        // Display the breadcrumb facets.
        $("#products-filter-breadcrumbs").empty().html(data.facetsBreadcrumbs);
        initClickHandlers();
        if (generateCategoryFilters) {
            displayCategoryFilters(data.categories);
        }
        // Is there a message?
        if (data.message) {
            $("#products-index-message").html(data.message);
        }                       
    }

    function clearFacet(event) {
        $(this).closest(".facet").find(".facet-checkbox").prop("checked", false);
        executeSearch();
    }

    function clearFacetCheckbox(event) {
        var facetName = $(this).data("name");
        var facetValue = $(this).data("value");
        $(".facet-checkbox[name='" + facetName + "'][value='" + facetValue + "']").prop("checked", false);
        $(this).closest(".facet-breadcrumb").addClass("d-none");  // hide the breadcrumb element immediately, so we don't have to wait for the search results
        executeSearch();
    }

    function putSelectedFacetsIntoQueryString() {
        var valueGuids = [];
        $(".facet-checkbox:checked").each(function (i, element) {
            valueGuids.push($(element).data("valueGuid"));
        });
        if (valueGuids.length) {
            urlUtils.pushParamIntoLink("filters", valueGuids.join('|'));
        }
        else
            urlUtils.popParamFromLink("filters");
    }

    function displayCategoryFilters(generatedHtml) {
        $(".category-navigation .filter").html(generatedHtml);
        $(".category-navigation .filter .filter-link").off("click").on("click", categoryFilterClicked);
    }

    function categoryFilterClicked(event) {
        if ($(this).hasClass("current")) return; // This category is already selected. Nothing to do.
        $(".category-navigation .filter .filter-link.current").removeClass("current");
        $(this).addClass("current");
        currentCategoryFilter = $(this).data("categoryId");
        executeSearch(null, true);
    }

    function spinner(what) {
        if (what === "show") {          
            $("#products-index-spinner").removeClass("d-none");
            if(generateCategoryFilters) $(".category-navigation .spinner-wrapper").removeClass("d-none");
        }
        else {
            $("#products-index-spinner").addClass("d-none");
            if (generateCategoryFilters) $(".category-navigation .spinner-wrapper").addClass("d-none");
        }
    }

    var pageSize = $(window).width() < 1024
        ? Number($("#products-index").data("productsPerPageMobile"))
        : Number($("#products-index").data("productsPerPageDesktop"));
    var currentDisplayCountLimit = pageSize;

    function setScrollLoading() {
        scrollDebounce = true;
        $(window).on("scroll", function () {
            if (scrollDebounce) {
                scrollDebounce = false;
                var productsIndexDiv = $("#products-index");
                var offset = productsIndexDiv.offset();
                var top = offset.top;
                var bottom = top + productsIndexDiv.height();             
                if (window.scrollY + window.innerHeight >= bottom) {
                    var total = $("#products-index .products-index-item").length;
                    if (currentDisplayCountLimit >= total) return;
                    currentDisplayCountLimit += pageSize;
                    if (currentDisplayCountLimit > total) currentDisplayCountLimit = total;
                    shuffle.filter(shuffleInstance, currentDisplayCountLimit);
                }

                setTimeout(function () { scrollDebounce = true; }, 200);
            }
        });
    }

    setScrollLoading();
    filterFacetsPosition.init();
    initClickHandlers();
    var generateCategoryFilters = $("#products-index").data("isCollectionCategory");
    var currentCategoryFilter = "0";

    var shuffleInstance = shuffle.init("#products-index", ".products-index-item");

    executeSearch(null, null, true); // execute initial search

});
define("ProductsIndex/main", function(){});

